(() => {
  if (customElements.get('floating-product-button')) return;

  customElements.define('floating-product-button', class extends HTMLElement {
    connectedCallback() {
      // Quick-buy clones must never create a second fixed purchase bar.
      if (this.closest('.quickbuy-container')) return;
      this.section = this.closest('.shopify-section');
      this.form = this.section?.querySelector(`#${CSS.escape(this.dataset.formId)}`);
      this.customAction = this.section?.querySelector('.custom_add_to_cart_button_wrapper button');
      this.action = this.customAction || this.form?.querySelector('[type="submit"]');
      this.anchor = this.action || this.form;
      if (!this.anchor) return;
      this.button = this.querySelector('button');
      this.variants = JSON.parse(this.querySelector('[data-floating-variants]').textContent);
      this.defaultImage = this.querySelector('img').getAttribute('src');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.update = () => this.sync();
      this.button.addEventListener('click', () => {
        this.sync();
        if (this.button.disabled || !this.action) return;
        const variant = this.selectedVariant();
        if (!this.customAction && !variant) {
          this.form.closest('.product-form').scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.section.querySelector('.option-selector input, .option-selector select, .option-selector button')?.focus({ preventScroll: true });
          return;
        }
        // Click the original action to preserve its validation, properties and AJAX cart handlers.
        this.action.click();
        this.sync();
      }, options);
      this.section.addEventListener('change', this.update, options);
      window.addEventListener('scroll', this.update, { ...options, passive: true });
      window.addEventListener('resize', this.update, options);
      this.observer = new MutationObserver(this.update);
      if (this.action) this.observer.observe(this.action, { attributes: true, childList: true, subtree: true });
      this.resizeObserver = new ResizeObserver(() => this.setHeight());
      this.resizeObserver.observe(this);
      // The theme emits jQuery events for variant changes, including programmatic option changes.
      this.productForm = this.form?.closest('.product-form');
      if (window.jQuery && this.productForm) window.jQuery(this.productForm).on('variantChanged.floatingProduct', this.update);
      this.sync();
    }

    selectedVariant() {
      const id = this.form?.querySelector('[name="id"]')?.value;
      return this.variants.find(variant => String(variant.id) === id);
    }

    sync() {
      const variant = this.selectedVariant();
      if (variant) this.querySelector('[data-floating-price]').innerHTML = variant.price;
      const image = this.querySelector('img');
      const src = variant?.image || this.defaultImage;
      if (src && image.getAttribute('src') !== src) image.src = src;
      image.hidden = !src;
      const busy = this.action?.classList.contains('adding') || this.action?.getAttribute('aria-busy') === 'true' || (variant?.available && this.action?.disabled);
      const unavailable = !this.customAction && variant && !variant.available;
      this.button.disabled = !this.action || busy || unavailable || this.action.disabled;
      this.button.setAttribute('aria-busy', String(Boolean(busy)));
      this.button.textContent = unavailable || !this.action ? 'אזל מהמלאי' : busy ? 'מוסיפים לסל…' : !this.customAction && !variant ? 'בחירת אפשרויות' : 'לרכישה';
      // Show after the original purchase controls have scrolled above the viewport.
      this.hidden = this.anchor.getBoundingClientRect().bottom > 0;
      this.setHeight();
    }

    setHeight() {
      document.body.style.setProperty('--floating-product-height', `${this.hidden ? 0 : this.getBoundingClientRect().height}px`);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      if (window.jQuery && this.productForm) window.jQuery(this.productForm).off('variantChanged.floatingProduct', this.update);
      if (this.anchor) document.body.style.removeProperty('--floating-product-height');
    }
  });
})();
